import { render, staticRenderFns } from "./VehicleDataMaintain.vue?vue&type=template&id=f6a4804a"
import script from "./VehicleDataMaintain.vue?vue&type=script&lang=js"
export * from "./VehicleDataMaintain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports